
  <div class="homepage-container" *ngIf="announcement">
    <div class="announcement-bar">
      <img [src]="announcement.imageUrl">
      <p [innerHTML]="announcement.message"></p>
      <a class="button" [href]="announcement.linkUrl">Learn More</a>
    </div>
  </div>


// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/embedded/announcement-bar/announcement-bar.component.ts.AnnouncementBarComponent.html